/**
 * Locale Registry — AUTO-GENERATED FROM BACKEND
 *
 * Source: backend/src/modules/i18n/registry.json (version 2026-05-04.1, hash 6612139fa2d7)
 * Generator: frontend/scripts/sync-locales.js
 *
 * DO NOT EDIT THIS FILE. Edit the registry JSON in the backend, then run
 * `npm run sync-locales` (or `npm run build` which calls it via prebuild).
 *
 * CI fails any build where this file is out of sync with the registry.
 */

export type UiLocale = 'en' | 'ar' | 'ur' | 'bn' | 'es' | 'tr' | 'ur-Latn';
export type TranslationLocale = 'en' | 'ar' | 'ur' | 'bn' | 'es' | 'tr';

export interface LocaleConfigEntry {
  readonly code: UiLocale;
  readonly rtl: boolean;
  readonly translatable: boolean;
  readonly fallbackTo?: TranslationLocale;
}

export const LOCALE_REGISTRY_VERSION = '2026-05-04.1';
export const LOCALE_REGISTRY_HASH = '6612139fa2d7';

export const DEFAULT_LOCALE: UiLocale = 'en';

export const SUPPORTED_LOCALES = ['en', 'ar', 'ur', 'bn', 'es', 'tr', 'ur-Latn'] as const;

export const TRANSLATION_TARGETS = ['en', 'ar', 'ur', 'bn', 'es', 'tr'] as const;

export const RTL_LOCALES: ReadonlySet<UiLocale> = new Set(['ar', 'ur']);

export const LOCALES: readonly LocaleConfigEntry[] = [
  {
    "code": "en",
    "rtl": false,
    "translatable": true
  },
  {
    "code": "ar",
    "rtl": true,
    "translatable": true
  },
  {
    "code": "ur",
    "rtl": true,
    "translatable": true
  },
  {
    "code": "bn",
    "rtl": false,
    "translatable": true
  },
  {
    "code": "es",
    "rtl": false,
    "translatable": true
  },
  {
    "code": "tr",
    "rtl": false,
    "translatable": true
  },
  {
    "code": "ur-Latn",
    "rtl": false,
    "translatable": false,
    "fallbackTo": "ur"
  }
];

const BY_CODE = new Map<UiLocale, LocaleConfigEntry>(
  LOCALES.map(l => [l.code, l] as const),
);

/**
 * Map a UI locale (what the user picked) to the translation locale whose stored
 * content should be served. Identity for translatable locales; follows
 * `fallbackTo` for presentation-only locales (e.g. ur-Latn → ur).
 */
export function toTranslationLocale(uiLocale: UiLocale): TranslationLocale {
  const entry = BY_CODE.get(uiLocale);
  if (!entry) return DEFAULT_LOCALE as TranslationLocale;
  if (entry.translatable) return entry.code as TranslationLocale;
  return (entry.fallbackTo ?? DEFAULT_LOCALE) as TranslationLocale;
}

export function isSupportedLocale(code: string): code is UiLocale {
  return BY_CODE.has(code as UiLocale);
}

export function isRTL(code: string): boolean {
  return RTL_LOCALES.has(code as UiLocale);
}
